import React from "react";
import {
  FontAwesomeIcon
} from '@fortawesome/react-fontawesome'
import {
  faFacebookSquare
}
from '@fortawesome/free-brands-svg-icons'
import {
  faTwitterSquare
}
  from '@fortawesome/free-brands-svg-icons'
import { faEnvelope } from '@fortawesome/free-solid-svg-icons'


const ShareButtons = () => (
  <span>
    <a
      href="https://www.facebook.com/sharer/sharer.php?u=https%3A%2F%2Fkanepes.lv&quote=Kaņepes%20Kultūras%20Centrs"
      target="_blank"
      rel="noopener noreferrer"
      title="Share on Facebook"
      className="share-icon"
      onClick={() =>
        "window.open('https://www.facebook.com/sharer/sharer.php?u=' + encodeURIComponent(document.URL) + '&quote=' + encodeURIComponent(document.URL)); return false;"
      }
    >
      <FontAwesomeIcon icon={faFacebookSquare} />
      <span className="sr-only">Share on Facebook</span>
    </a>
    <a
      href="https://twitter.com/intent/tweet?source=https%3A%2F%2Fkanepes.lv&text=Kaņepes%20Kultūras%20Centrs%20https%3A%2F%2Fkanepes.lv&via=kanepeskc"
      target="_blank"
      rel="noopener noreferrer"
      title="Tweet"
      className="share-icon"
      onClick={() =>
        "window.open('https://twitter.com/intent/tweet?text=Kaņepes%20Kultūras%20Centrs:%20' + encodeURIComponent(document.URL)); return false;"
      }
    >
      <FontAwesomeIcon icon={faTwitterSquare} />
      <span className="sr-only">Tweet</span>
    </a>
    <a
      href="mailto:?subject=Kaņepes Kultūras centrs&body=https://www.kanepes.lv"
      target="_blank"
      rel="noopener noreferrer"
      title="Share via E-mail"
      className="share-icon"
    >
      <FontAwesomeIcon icon={faEnvelope} />
      <span className="sr-only">E-mail</span>
    </a>
  </span>
);

export default ShareButtons;
